<template>
            <div v-if="product.lowStock" class="inline-block mb-2 mr-2 px-2.5 py-0.5 text-yellow-800 text-xs font-medium bg-yellow-100 rounded-full">Poca existencia</div>
        <img :src="product.image" :alt="product.name" class="mb-2 w-full h-48 object-cover" />
        <h3 class="mb-2 text-lg font-bold">{{ product.name }}</h3>
        <div class="flex justify-between">
          <div>
            <span class="text-gray-600 text-sm">CÓDIGO:</span><br />
            <span class="text-black text-gray-600 font-bold">{{ product.code }}</span>
          </div>

          <div id="show-content">
            <span class="text-gray-600 text-sm">REF:</span><br />
            <span class="text-lg font-bold">{{ product.price }}</span>
          </div>
        </div>
        <div class="flex items-center">
        <button class="px-4 py-2 text-white font-bold bg-green-500 hover:bg-green-700 rounded-l">Añadir</button>
        <div class="flex border border-gray-300 rounded-r">
          <button class="px-3 py-2 hover:bg-gray-200" @click="decreaseQuantity">-</button>
          <span class="px-4 py-2">{{ quantity }}</span>
          <button class="px-3 py-2 hover:bg-gray-200" @click="increaseQuantity">+</button>
        </div>
        </div>
</template>

<script>
export default {
    props: {
        product: Object
    },
    data() {
        return {
            quantity: 0
        }
    },
    methods: {
    increaseQuantity() {
      this.quantity++
    },
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--
      }
    },
  },
}
</script>